import { IMenuItem } from '@/store/state'
import axios from 'axios'

const headers = {
	'X-Requested-With': 'XMLHttpRequest',
	'Accept': 'application/json',
}

export interface IGetChildrenPayload {
	id: string
	level: number
}

const stringifyParameters = (paramObject: any) => {
    let paramArray: string[] = [];
    Object.keys(paramObject).forEach(key => {
        let paramString = `${key}=${paramObject[key]}`;
        paramArray.push(paramString);
    })
    let returnString = '?' + paramArray.join('&');
    return returnString;
}

export const getMenuChildren = (childrenEndpoint: string, params: IGetChildrenPayload): Promise<IMenuItem[]> => {
    let stringifiedParameters = stringifyParameters({
        id: params.id,
        level: params.level
    })
    let url = childrenEndpoint + stringifiedParameters;
    return axios.get(url, { headers })
        .then((response:any) => {
            return response.data
        })
        .catch((searchError:any) => {
            console.error({
                searchError
            })
            return {} as IMenuItem[]
        })
}

export const getMenu = (menuEndpoint: string, params: {isDesktop: boolean}): Promise<IMenuItem[]> => {
    let stringifiedParameters = stringifyParameters({
        isDesktop: params.isDesktop,
    })
    let url = menuEndpoint + stringifiedParameters;
    return axios.get(url, { headers })
        .then((response:any) => {
            return response.data
        })
        .catch((searchError:any) => {
            console.error({
                searchError
            })
            return {} as IMenuItem[]
        })
}